export const APIENDPOINTS = {
  FETCH_GRADE: "/grade-master",
  POST_GRADE: "/grade-master",
  UPDATE_GRADE: (gradeId) =>
    `/grade-master/${gradeId}`,
  DELETE_GRADE : (gradeId) => `/grade-master/${gradeId}`,
  UPDATE_STATUS:(gradeId) => `/grade-master/status/${gradeId}`
};
